import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import { getCurrencySymbolByCode } from '@/common/helpers/helpers'
import commonServices from '@/common/services/services'

const useStoreCurrencySymbol = () => {
  const { info } = useContext(AppContext)
  const { data: currencies } = useFetch(commonServices.getCurrencies, { doInitialRequest: true })

  const storeCurrencyCode = info?.selectedStore?.currency
  const storeCurrencySymbol = getCurrencySymbolByCode(storeCurrencyCode, currencies)

  return { currencies, storeCurrencyCode, storeCurrencySymbol }
}

export default useStoreCurrencySymbol
